import React, { useEffect, useReducer } from "react";
import { useParams } from "react-router-dom";

import Html from "./html";
import Reducer from "./reducer";
import Context from "./context";
import { initialState } from "./initialState";
import { loadData } from "./service";

const FtmPaymentsHistories = () => {
    let { ftm_id } = useParams();
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        loadData({
            ftm_id: ftm_id,
            page_number: state.current_page,
            dispatch: dispatch
        });
    }, [state.current_page]); 

    return (
        <Context.Provider value={{ftm_id, state, dispatch}}>
            <Html/>
        </Context.Provider>
    );
}

export default FtmPaymentsHistories;